import AfterFetchComponent from '@/components/base/AfterFetchComponent'
import ConcentrationOfInquiriesModal
  from "@/components/dashboard/concentration-of-inquiries/modal/ConcentrationOfInquiriesModal.vue";
import CreateNewCustomerServiceCRMContact
  from "@/components/dashboard/customer-service/components/CreateNewCustomerServiceCRMContact.vue";
import MemberAccountsGrid from "@/components/dashboard/customer-service/components/MemberAccountsGrid.vue";
import SearchEmployer from "@/components/dashboard/customer-service/components/SearchEmployer.vue";
import SearchMember from "@/components/dashboard/customer-service/components/SearchMember.vue";
import ShowDocumentsComponents from "@/components/dashboard/search-customer-service/ShowDocumentsComponents.vue";
import {StoreNamespace} from "@/globals/StoreNamespaceGlobal";
import {CrmFilterType} from "@/models/CrmFilterType";
import {EmployerCRMDetails, MemberCRMDetails} from "@/store/modules/customerService";
import {ExportType} from "@payroll/grid-widget/src/models/ExportType";
import {GridColumn} from "@payroll/grid-widget/src/models/GridColumn";
import {BaseRequest, KeyValuePair} from "@payroll/optimus-common";
import {FieldType, SearchFieldModel} from "@payroll/search-results-widget/src/models/SearchField.model";
import Component from 'vue-class-component'
import {Action, Getter, Mutation} from "vuex-class";


@Component({
  components: {
    SearchMember,
    SearchEmployer,
    MemberAccountsGrid,
    CreateNewCustomerServiceCRMContact,
    ShowDocumentsComponents,
    ConcentrationOfInquiriesModal
  }
})
export default class ConcentrationOfInquiriesComponent extends AfterFetchComponent {
  @Action('fetchCRMContacts', StoreNamespace.CUSTOMER_SERVICE) fetchCRMContacts: any
  @Action('exportCRMContacts', StoreNamespace.CUSTOMER_SERVICE) exportCRMContacts: any
  @Action('getAllStatusesTypes', StoreNamespace.CUSTOMER_SERVICE) getAllStatusesTypes: any
  @Action('getSubjectOfArrival', StoreNamespace.CUSTOMER_SERVICE) getSubjectOfArrival: any;
  @Action('getServicePriorities', StoreNamespace.CUSTOMER_SERVICE) getServicePriorities: any;
  @Action('getAllCRMUsers', StoreNamespace.CUSTOMER_SERVICE) getAllCRMUsers: any;
  @Action('getMemberDetails', StoreNamespace.CUSTOMER_SERVICE) getMemberDetails: any;
  @Action('getEmployerDetails', StoreNamespace.CUSTOMER_SERVICE) getEmployerDetails: any;
  @Action('getUsersByDepartmentId', StoreNamespace.CUSTOMER_SERVICE) getUsersByDepartmentId: any;
  @Action('updateRoutingUser', StoreNamespace.CUSTOMER_SERVICE) updateRoutingUser: any;

  @Getter('getReferralStatusLobby', StoreNamespace.CUSTOMER_SERVICE) getReferralStatusLobby!: string;

  @Mutation('setReferralStatusLobby', StoreNamespace.CUSTOMER_SERVICE) private setReferralStatusLobby: any;


  private columns: GridColumn[] = []
  private searchFields: SearchFieldModel[] = []

  private contactStatuses: KeyValuePair[] = []
  private departmentTypes: KeyValuePair[] = []
  private contactTypes: KeyValuePair[] = []
  private usersCRM: KeyValuePair[] = []
  private subjectsCRM: KeyValuePair[] = []
  private userForRoutingList: KeyValuePair[] = []
  private archiveFlagOptions: KeyValuePair[] = []
  private servicePrioritiesList: any[] | undefined = []

  private selectedUserForRouting: KeyValuePair | null = null
  private showAddNewContactForCustomerService: boolean = false
  private crmId: number = -1;
  private memberCRMDetails: MemberCRMDetails | null = null;
  private employerCRMDetails: EmployerCRMDetails | null = null;
  private memberAccounts: any[] = []
  private uniqueIdentifier: any = null;
  private member: any = null;
  private checkBoxCheckAllProperty = false;
  private showMainPopup: boolean = false;
  private showRoutingContactsToUserPopup: boolean = false;
  private showNotSelectedInquiresPopup: boolean = false;
  private crmFilterType : CrmFilterType | null = null
  private ExportType = ExportType


  mounted() {
    this.initArchiveFlagOptions();

    this.getAllCRMUsers({
      requestorCallback: this
    })

    this.getAllStatusesTypes({
      requestorCallback: this
    })

    this.getSubjectOfArrival({
      requestorCallback: this
    })

    this.getServicePriorities({
      requestorCallback: this
    })

  }

  created() {
    this.crmFilterType = null;
  }

  private initArchiveFlagOptions() {
    this.archiveFlagOptions.push(
      {
        value: 'false',
        description: this.$t('concentrationOfInquiries.no').toString()
      },
      {
        value: 'true',
        description: this.$t('concentrationOfInquiries.yes').toString()
      }
    )
  }

  beforeDestroy() {
    this.setReferralStatusLobby("");
  }

  private currentInquiries: any = []
  private inquiriesForAssociation: any = []

  onSuccess(data?: any, requestName?: string, message?: string, success?: boolean): void {
    switch (requestName) {
      case 'CRMContacts':
        const gridData = data.results.map((result: any) => {
          return ({...result, isCheckBoxSelected: false});
        })

        if (this.lastSearchObject.pageNumber === 0) {
          this.currentInquiries = [...gridData];
        } else {
          this.currentInquiries = [...this.currentInquiries, ...gridData]
        }


        this.$emit('successResults', {...data, result: gridData});
        break;
      case 'statusesTypes':
        this.contactTypes = data.contactTypes;
        this.contactStatuses = data.contactStatuses;
        this.departmentTypes = data.departmentTypes;
        this.initColumns()
        this.getGridData({
          pageNumber: 0,
          pageSize: 10,
          archiveFlag: {
            value: 'false',
            description: this.$t('concentrationOfInquiries.no').toString()
          },
          contactTypes: this.getInitialSelectedContactTypes()
        });
        break;
      case 'getSubjectOfArrival':
        this.handleGettingSubjectsMap(data);
        break;
      case 'getAllCRMUsers':
        this.usersCRM = data;
        this.initSearchFields()
        break;
      case 'getMemberDetails':
        this.memberCRMDetails = data;
        this.memberAccounts = []
        if (this.memberCRMDetails) {
          this.memberAccounts = this.memberCRMDetails.accountsList
        }
        break;
      case 'getEmployerDetails':
        this.employerCRMDetails = data
        break;
      case 'exportCRMContacts':
        data.fileExtension = 'xlsx'
        this.$emit('successExport', data)
        break

      case 'getUsersByDepartmentId':
        this.userForRoutingList = data.users
        break;

      case 'updateRoutingUser':
        this.onClosePopup()
        this.showAfterSuccessfullyActionPopup("ניתוב הפניות בוצע בהצלחה")
        break
      case 'servicePriorities':
        this.servicePrioritiesList = data
        break;
    }
  }

  private handleGettingSubjectsMap(data: any) {
    for (let mapFromDepartmentToSubjectListKey in data.mapFromDepartmentToSubjectList) {
      this.subjectsCRM.push(...data.mapFromDepartmentToSubjectList[mapFromDepartmentToSubjectListKey])
    }

    this.sortSubjectsCRM();

    this.initSearchFields()
  }

  private sortSubjectsCRM() {
    this.subjectsCRM.sort((a, b) => {
      const nameA = a.description;
      const nameB = b.description;
      return nameA.localeCompare(nameB);
    });
  }

  initSearchFields(): void {
    this.searchFields = []
    if (this.contactStatuses.length === 0) {
      return;
    }

    let initialSelectedContactTypes: any = this.getInitialSelectedContactTypes();
    if (initialSelectedContactTypes === undefined) {
      initialSelectedContactTypes = {}
    }

    this.searchFields.push({
      label: 'concentrationOfInquiries.department',
      property: 'department',
      fieldType: FieldType.SELECT_FIELD,
      selectOptions: this.departmentTypes,
      initialSelected: {},
      bootstrapColumn: 2
    })
    this.searchFields.push({
      label: 'concentrationOfInquiries.contactSubject',
      property: 'subjectCRM',
      fieldType: FieldType.SELECT_FIELD,
      selectOptions: this.subjectsCRM,
      initialSelected: {},
      bootstrapColumn: 3
    })
    this.searchFields.push({
      label: 'concentrationOfInquiries.contactStatus',
      property: 'contactStatus',
      fieldType: FieldType.SELECT_FIELD,
      selectOptions: this.contactStatuses,
      initialSelected: {},
      bootstrapColumn: 2
    })
    this.searchFields.push({
      label: 'concentrationOfInquiries.createDate',
      property: 'createDate',
      fieldType: FieldType.DATE_FIELD,
      bootstrapColumn: 2
    })
    this.searchFields.push({
      label: 'concentrationOfInquiries.upToCreateDate',
      property: 'upToCreateDate',
      fieldType: FieldType.DATE_FIELD,
      bootstrapColumn: 2
    })

    this.searchFields.push({
      label: 'concentrationOfInquiries.archiveFlag',
      property: 'archiveFlag',
      fieldType: FieldType.SELECT_FIELD,
      selectOptions: this.archiveFlagOptions,
      initialSelected: this.archiveFlagOptions[0],
      advancedOnly: false,
      bootstrapColumn: 1
    })

    this.searchFields.push({
      label: 'concentrationOfInquiries.crmContactId',
      property: 'crmContactId',
      fieldType: FieldType.NUMBER_FIELD,
      advancedOnly: true,
      bootstrapColumn: 3
    })

    this.searchFields.push({
      label: 'concentrationOfInquiries.contactTypes',
      property: 'contactTypes',
      fieldType: FieldType.SELECT_FIELD,
      selectOptions: this.contactTypes,
      initialSelected: initialSelectedContactTypes,
      bootstrapColumn: 3,
      advancedOnly: true
    })

    this.searchFields.push({
      label: 'concentrationOfInquiries.uniqueIdentifier',
      property: 'uniqueIdentifier',
      fieldType: FieldType.TEXT_FIELD,
      advancedOnly: true,
      bootstrapColumn: 3
    })
    this.searchFields.push({
      label: 'concentrationOfInquiries.name',
      property: 'name',
      fieldType: FieldType.TEXT_FIELD,
      advancedOnly: true,
      bootstrapColumn: 3
    })
    this.searchFields.push({
      label: 'concentrationOfInquiries.createdUser',
      property: 'createdUser',
      fieldType: FieldType.SELECT_FIELD,
      selectOptions: this.usersCRM,
      initialSelected: {},
      advancedOnly: true,
      bootstrapColumn: 3
    })
    this.searchFields.push({
      label: 'concentrationOfInquiries.lastRoutingUser',
      property: 'lastRoutingUser',
      fieldType: FieldType.SELECT_FIELD,
      selectOptions: this.usersCRM,
      initialSelected: {},
      advancedOnly: true,
      bootstrapColumn: 3
    })
    this.searchFields.push({
      label: 'concentrationOfInquiries.fullKitDate',
      property: 'fullKitDate',
      fieldType: FieldType.DATE_FIELD,
      advancedOnly: true,
      bootstrapColumn: 3
    })

    this.searchFields.push({
      label: 'concentrationOfInquiries.priority',
      property: 'servicePriorityIndex',
      fieldType: FieldType.SELECT_FIELD,
      selectOptions: this.servicePrioritiesList,
      initialSelected: {},
      advancedOnly: true,
      bootstrapColumn: 3
    })
  }

  private getInitialSelectedContactTypes() {
    return this.contactTypes.find(contactType => contactType.description === this.getReferralStatusLobby);
  }

  private initColumns(): void {
    this.columns.push({property: 'crmId', header: 'concentrationOfInquiries.crmId', hideSorting: true} as GridColumn)
    this.columns.push({
      property: 'uniqueIdentifier',
      header: 'concentrationOfInquiries.uniqueIdentifier',
      hideSorting: true
    } as GridColumn)
    this.columns.push({property: 'name', header: 'concentrationOfInquiries.name'} as GridColumn)
    this.columns.push({property: 'statusCRM', header: 'concentrationOfInquiries.contactStatus'} as GridColumn)
    this.columns.push({
      property: 'department',
      header: 'concentrationOfInquiries.department',
      hideSorting: true
    } as GridColumn)
    this.columns.push({property: 'arrivalSubject', header: 'concentrationOfInquiries.contactSubject'} as GridColumn)
    this.columns.push({
      property: 'currentReferralStatus',
      header: 'concentrationOfInquiries.contactTypes'
    } as GridColumn)
    this.columns.push({property: 'dateCreated', header: 'concentrationOfInquiries.createDate'} as GridColumn)
    this.columns.push({
      property: 'createdUser',
      header: 'concentrationOfInquiries.createdUser',
      hideSorting: true
    } as GridColumn)
    this.columns.push({
      property: 'lastRoutingUser',
      header: 'concentrationOfInquiries.routingUser',
      hideSorting: true
    } as GridColumn)
    this.columns.push({
      property: 'priority',
      header: 'concentrationOfInquiries.priority',
      hideSorting: true
    } as GridColumn)
  }

  private lastSearchObject: any = {}

  private getGridData(searchObject: any) {
    searchObject.pageSize = 10;
    this.lastSearchObject = {...searchObject}


    this.fetchCRMContacts({
      requestorCallback: this,
      requestBody: searchObject,
    });
  }


  private onClosePopup() {
    this.showMainPopup = false;
    this.showRoutingContactsToUserPopup = false
    this.crmId = -1
    this.member = null;
    this.uniqueIdentifier = null
  }

  private onRowClick(row: any) {
    this.crmId = row.crmId
    this.showMainPopup = true;
    this.member = row.member;
    this.uniqueIdentifier = row.uniqueIdentifier
  }

  onAddClick() {
    this.showAddNewContactForCustomerService = true
  }

  private onCloseAddNewContact() {
    this.showAddNewContactForCustomerService = false
    this.memberCRMDetails = null
    this.employerCRMDetails = null
    this.crmFilterType = null;
  }

  private onSelectedMember(member: any) {
    this.crmFilterType = CrmFilterType.MEMBER

    this.getMemberDetails({
      pathVariable: member.id,
      requestorCallback: this
    })
  }

  private onSelectedEmployer(employer: any) {
    this.crmFilterType = CrmFilterType.EMPLOYER

    this.getEmployerDetails({
      pathVariable: employer.id,
      requestorCallback: this
    })
  }

  private onSubmitEdit() {
    this.showMainPopup = false;
  }

  private onCloseSuccessAddingNewContact() {

    this.onCloseAddNewContact();
    this.showSuccessPopupMessage('customerService.popup.successMessage')
  }

  private showSuccessPopupMessage(message: string) {
    this.$root.$emit('showAlertNotification', {
      toShow: true,
      message: message,
      icon: 'checkCircle',
      secondsToDisappear: 3
    })
  }

  get exportFileName(): string {
    return '' + this.$t('concentrationOfInquiries.excelTitle')
  }

  onExportGrid(exportType: ExportType, gridColumns: Array<GridColumn>, searchObject: any): void {
    let exportColumns: GridColumn[] = []
    this.exportCRMContacts({
      requestBody: {
        headerText: this.exportFileName,
        exportType: exportType,
        columnsList: exportColumns,
        searchObject: searchObject
      } as BaseRequest,
      requestorCallback: this
    })
  }

  onShowRoutingUserPopup() {

    this.userForRoutingList = []
    this.getUsersByDepartmentId({
      requestorCallback: this,
      pathVariable: this.lastSearchObject.department.value
    })


    this.inquiriesForAssociation = this.currentInquiries.filter((row: any) => row.isCheckBoxSelected)

    if (this.inquiriesForAssociation.length === 0) {
      this.showNotSelectedInquiresPopup = true;
      return
    }

    this.showRoutingContactsToUserPopup = true;
  }

  private onCheckboxClick(checked: boolean, result: any) {
    if (!checked) {
      this.checkBoxCheckAllProperty = false;
    }

    this.currentInquiries.forEach((row: any) => {
      if (row.id === result.id) {
        row.isCheckBoxSelected = checked;
      }
    })
  }


  private onCheckboxCheckAll(checkAll: boolean) {

    this.checkBoxCheckAllProperty = checkAll;


    this.currentInquiries.forEach((row: any) => {
      row.isCheckBoxSelected = checkAll
    });


  }

  onRoutingContactsToUser() {
    const body = {
      userToRouting: this.selectedUserForRouting,
      contactIdList: this.inquiriesForAssociation.map((row: any) => row.crmId)
    }


    this.updateRoutingUser({
      requestorCallback: this,
      requestBody: body
    })
  }

  private showAfterSuccessfullyActionPopup(message: string) {
    this.$root.$emit('showAlertNotification', {
      toShow: true,
      message: message,
      icon: 'checkCircle',
      secondsToDisappear: 3
    })
  }
}